import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaTimes, FaPlus, FaFileAlt } from 'react-icons/fa';

const Button = ({ onClick, children, variant = 'primary', className = '' }) => {
  const baseClasses = `px-4 py-2 rounded-md font-medium text-sm focus:outline-none flex items-center gap-2 justify-center`;
  const variants = {
    primary: 'bg-purple-600 text-white hover:bg-purple-700',
    secondary: 'bg-gray-100 text-gray-700 hover:bg-gray-200',
    danger: 'bg-red-500 text-white hover:bg-red-600',
    whatsapp: 'bg-green-500 text-white hover:bg-green-600',
  };
  return (
    <button
      onClick={onClick}
      className={`${baseClasses} ${variants[variant]} ${className}`}
    >
      {children}
    </button>
  );
};

const Input = ({ label, value, onChange, placeholder = '', type = 'text', component = 'input', className = '' }) => {
  const Element = component;
  return (
    <div className="mb-4">
      {label && <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>}
      <Element
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 ${className}`}
      />
    </div>
  );
};

const PopupPage = ({ initialModal, onClose }) => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [currentFile, setCurrentFile] = useState(null);

  useEffect(() => {
    if (initialModal) {
      handleOpenModal(initialModal);
    }
  }, [initialModal]);

  const handleOpenModal = (type, file = null) => {
    if (type === 'editFile') {
      setCurrentFile(file);
    }
  };

  const handleDeleteFile = (index) => {
    const updatedFiles = [...uploadedFiles];
    updatedFiles.splice(index, 1);
    setUploadedFiles(updatedFiles);
  };

  const handleFileUpload = (event) => {
    const files = Array.from(event.target.files);
    setUploadedFiles((prev) => [...prev, ...files]);
  };

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-md p-8 max-w-lg w-full relative">
        <button
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
          onClick={onClose}
        >
          <FaTimes className="text-lg" />
        </button>
        <h1 className="text-xl font-bold mb-6">Popup Page</h1>
        <label className="block mb-4">
          <Button
            variant="primary"
            className="flex items-center"
            onClick={() => document.getElementById('fileUploadInput').click()}
          >
            <FaPlus /> Upload File
          </Button>
          <input
            id="fileUploadInput"
            type="file"
            className="hidden"
            onChange={handleFileUpload}
            multiple
          />
        </label>
        <div>
          {uploadedFiles.length > 0 ? (
            uploadedFiles.map((file, index) => (
              <div key={index} className="flex justify-between items-center mb-2">
                <span className="truncate w-2/3">{file.name}</span>
                <div className="flex gap-2">
                  <Button
                    variant="secondary"
                    className="text-xs"
                    onClick={() => handleOpenModal('editFile', file)}
                  >
                    Edit
                  </Button>
                  <Button
                    variant="danger"
                    className="text-xs"
                    onClick={() => handleDeleteFile(index)}
                  >
                    Delete
                  </Button>
                </div>
              </div>
            ))
          ) : (
            <p className="text-gray-500 text-sm">No files uploaded yet.</p>
          )}
        </div>
        {currentFile && (
          <div className="mt-6 p-4 border rounded-md bg-gray-50">
            <h2 className="text-lg font-bold mb-4">Edit File</h2>
            <Input label="File Name" value={currentFile.name} onChange={() => {}} />
            <Input
              label="Description (Optional)"
              value="Description here..."
              onChange={() => {}}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PopupPage;
